var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useContext } from "react";
import { IconButton, Form } from "@brushfire/ui";
import { clearCart } from "../../../../../data/api";
import { useSelector, useDispatch } from "react-redux";
import { updateCartData } from "../../../../../store/Cart/actions";
import { setFormIsSubmitting } from "../../../../../store/AppState/actions";
import { clearInlineErrors, setInlineError } from "../../../../../store/AppState/actions";
import { AppFormContext } from "../../../../../App";
import WidgetFieldset from "../../../../Helpers/WidgetFieldset";
import useWidgetHistory from "../../../../../hooks/useWidgetHistory";
import ClearCartButton from "./ClearCartButton";
import useWidgetAnalytics from "../../../../../hooks/useWidgetAnalytics";
import { clearSubmittedForms } from "../../../../../store/Record/actions";
import { registrationPath } from "../../../../../data/helpers";
var useTypedSelector = useSelector;
var AttendeeCartHeader = function (_a) {
    var showBack = _a.showBack, onBackClick = _a.onBackClick, headerText = _a.headerText, _b = _a.showAdd, showAdd = _b === void 0 ? true : _b, _c = _a.showClear, showClear = _c === void 0 ? true : _c, resetMobileFlow = _a.resetMobileFlow, setCartTotalSeen = _a.setCartTotalSeen;
    var _d = __read(useState(false), 2), setShowCartModal = _d[1];
    var cart = useTypedSelector(function (store) { return store.cart; }).cart;
    var event = useTypedSelector(function (store) { return store.events; }).event;
    var isAutoRegMode = useTypedSelector(function (store) { return store.app; }).isAutoRegMode;
    var history = useWidgetHistory();
    var dispatch = useDispatch();
    var analytics = useWidgetAnalytics();
    var formikContext = useContext(AppFormContext).formikContext;
    var handleClearCart = function (values, formikHelpers) {
        var _a;
        dispatch(clearInlineErrors());
        dispatch(setFormIsSubmitting(true));
        if (cart) {
            clearCart(cart.cartId, (_a = event === null || event === void 0 ? void 0 : event.eventNumber.toString()) !== null && _a !== void 0 ? _a : "")
                .then(function () {
                resetMobileFlow();
                dispatch(updateCartData(history.replace));
                if (cart && event) {
                    dispatch(clearSubmittedForms(event.eventNumber.toString()));
                    analytics.removeFromCart(cart.attendees, event);
                }
                setCartTotalSeen(false);
            })
                .catch(function (err) {
                var _a;
                if (err.response.status !== 404) {
                    dispatch(setInlineError({ clearCartError: (_a = err.response) === null || _a === void 0 ? void 0 : _a.data.message }));
                }
                else {
                    resetMobileFlow();
                    dispatch(updateCartData(history.replace));
                    if (cart && event) {
                        dispatch(clearSubmittedForms(event.eventNumber.toString()));
                        analytics.removeFromCart(cart.attendees, event);
                    }
                    setCartTotalSeen(false);
                }
            })
                .finally(function () {
                formikContext === null || formikContext === void 0 ? void 0 : formikContext.setSubmitting(false);
                dispatch(setFormIsSubmitting(false));
                setShowCartModal(false);
            });
        }
    };
    if (!cart) {
        return null;
    }
    return (_jsx("div", { children: _jsx(Form, __assign({ useUnsavedPrompt: false, onSubmit: function (values, formikHelpers) {
                formikHelpers.setSubmitting(false);
            }, initialValues: {} }, { children: function (_a) {
                var formikContext = _a.formikContext;
                return (_jsx(WidgetFieldset, { children: _jsxs("div", __assign({ className: "d-flex align-items-center attendee-cart-header" }, { children: [showBack && (_jsx(IconButton, { icon: "arrow-left", ariaLabel: "Go back", classes: "m-right-sm", onClick: function () {
                                    onBackClick();
                                } })), _jsx("h4", __assign({ className: "h4 semi-bold mb-0" }, { children: headerText })), _jsxs("div", __assign({ className: "right-action-buttons d-flex align-items-center" }, { children: [showAdd && (_jsx(IconButton, { icon: "plus", ariaLabel: "Add Attendee", onClick: function () {
                                            if (event) {
                                                history.push(registrationPath(event, isAutoRegMode));
                                            }
                                        } })), showClear && _jsx(ClearCartButton, { onSubmit: handleClearCart, subject: "attendee" })] }))] })) }));
            } })) }));
};
export default AttendeeCartHeader;
